import { UiScopeToggleOption } from '../types/ui-scope-toggle-option.interface';

export const UI_SCOPE_TOGGLE_OPTIONS: readonly UiScopeToggleOption[] = [
  {
    value: 'me',
    label: 'Moje',
    iconLabel: 'Ja',
  },
  {
    value: 'home',
    label: 'Dom',
    iconLabel: 'D',
  },
  {
    value: 'all',
    label: 'Wszyscy',
    iconLabel: 'W',
  },
];
